import type {
  DashboardFilters,
  DashboardResponse,
  StatsSource,
} from '../types/dashboard.types';

export const STATS_SOURCE_LABELS: Record<StatsSource, string> = {
  official: 'Oficiales',
  pre_registered: 'Preinscriptos',
  consolidated: 'Consolidado',
};

export const isOfficialSource = (source?: StatsSource): boolean =>
  !source || source === 'official';

// Categories, types and segments are official-only: drop the source so they are
// not requested (nor cached) per source
export const officialOnlyFilters = (filters?: DashboardFilters): DashboardFilters | undefined => {
  if (!filters?.source) return filters;
  const rest = { ...filters };
  delete rest.source;
  return rest;
};

export const WITHOUT_DATA_COLUMNS = [
  { key: 'sinDatoPlazas', label: 'Sin dato plazas' },
  { key: 'sinDatoHabitaciones', label: 'Sin dato habitaciones' },
];

// The backend only sends withoutPlaces/withoutRooms for non-official sources
export const hasWithoutData = (response?: DashboardResponse<unknown>): boolean =>
  response?.total?.withoutPlaces !== undefined || response?.total?.withoutRooms !== undefined;

export const withoutDataTotals = (response?: DashboardResponse<unknown>): Record<string, unknown> => ({
  sinDatoPlazas: response?.total?.withoutPlaces ?? 0,
  sinDatoHabitaciones: response?.total?.withoutRooms ?? 0,
});
